(() => {
  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/®|™/g, '')
    .toLowerCase()
    .trim();

  // A rendszernevek illesztése normalizálva: a betűkódos utótag („(AG)"), a kis/nagybetű,
  // az írásjelek és a „BIONIKA " előtag nem számít — ugyanaz a szabály, mint a
  // márkaválasztóban (bnk-brand-picker.js).
  const bnorm = (value) => String(value || '')
    .replace(/\s*\([^)]*\)\s*$/, '')
    .toLowerCase()
    .replace(/^bionika\s+/, '')
    .replace(/[^a-z0-9]/g, '');

  // A kártyákat a főmenü adja (név + kollekció-URL). A pontos `custom.compatibility`
  // szűrő-értéket, a gyártónevet és a márka-bélyegképet a márkaválasztó adataiból
  // egészítjük ki: MP_COMPAT kulcsa „GYÁRTÓ|||MODELL", értéke a szűrő-érték.
  const SYSTEM_INFO = (() => {
    const source = window.MP_COMPAT || {};
    const entries = Object.keys(source).map((key) => {
      const parts = key.split('|||');
      return { key, maker: parts[0] || '', model: parts[1] || '', value: source[key] };
    });
    const byName = {};
    const byCode = {};
    const put = (target, name, entry) => {
      const k = bnorm(name);
      if (k && !target[k]) target[k] = entry;
    };
    // Sorrend = prioritás. A „gyártó modell" a legpontosabb: két rendszernek lehet AZONOS
    // szűrő-értéke (pl. CORTILOG CCL és CORTILOG SHORT CCL), ilyenkor a puszta érték
    // szerinti indexelés a másikra vinne (rossz bélyegkép).
    entries.forEach((entry) => put(byName, `${entry.maker} ${entry.model}`, entry));
    entries.forEach((entry) => put(byName, entry.value, entry));
    entries.forEach((entry) => put(byName, entry.model, entry));
    // Végső mentsvár: a névben zárójelezett betűkód („Ideiglenes (TCL)" -> TCL) — ezzel
    // az angol menücím („Temporary implant (TCL)") is megtalálja a magyar rendszernevet.
    entries.forEach((entry) => {
      [entry.model, entry.value].forEach((name) => {
        const code = /\(([^)]+)\)\s*$/.exec(String(name || ''));
        if (code) put(byCode, code[1], entry);
      });
    });
    const names = Object.keys(byName).sort((a, b) => b.length - a.length);
    return (rawName, rawCode) => {
      const k = bnorm(rawName);
      if (!k) return null;
      if (byName[k]) return byName[k];
      // A menücím bővebb lehet a rendszernévnél („MDI mini implantátum" -> „MDI"):
      // a leghosszabb olyan ismert név, amivel a cím KEZDŐDIK.
      const prefix = names.find((candidate) => candidate.length >= 3 && k.startsWith(candidate));
      if (prefix) return byName[prefix];
      const code = bnorm(rawCode);
      return (code && byCode[code]) || null;
    };
  })();

  const brandImage = (key) => {
    const url = (window.MP_IMG || {})[key];
    return url ? url.replace(/([?&]width=)\d+/, '$1360') : '';
  };

  const init = () => {
    const root = document.querySelector('[data-compatible-page]');
    if (!root) return;

    const input = root.querySelector('#CompatibleSearch');
    const clear = root.querySelector('.bnk-compatible__clear');
    const counter = root.querySelector('[data-compatible-count]');
    const empty = root.querySelector('[data-compatible-empty]');
    const cards = Array.from(root.querySelectorAll('.bnk-system-card'));
    // Csoportok a menü oszlopai szerint — a számlálókat csoportonként frissítjük.
    const groups = Array.from(root.querySelectorAll('[data-compatible-group]')).map((element) => ({
      element,
      cards: Array.from(element.querySelectorAll('.bnk-system-card')),
      count: element.querySelector('[data-compatible-group-count]'),
    }));

    const enrich = (card) => {
      const name = card.dataset.compatibleName || '';
      const info = SYSTEM_INFO(name, card.dataset.compatibleCode || '');
      const makerEl = card.querySelector('.bnk-system-card__maker');
      const titleEl = card.querySelector('.bnk-system-card__title');
      if (info) {
        card.dataset.compatibleValue = info.value;
        if (titleEl && info.model) titleEl.textContent = info.model;
        // A BIONIKA saját rendszereinél a „BIONIKA · SAJÁT RENDSZER" felirat marad.
        if (makerEl && info.maker && card.dataset.compatibleOwn !== '1') makerEl.textContent = info.maker;
        const image = brandImage(info.key);
        if (image) {
          const img = card.querySelector('.bnk-system-card__media img');
          if (img) {
            if (img.getAttribute('src') !== image) img.setAttribute('src', image);
          } else {
            const media = card.querySelector('.bnk-system-card__media');
            if (media) {
              const el = document.createElement('img');
              el.src = image;
              el.alt = '';
              el.loading = 'lazy';
              el.width = 180;
              el.height = 180;
              media.replaceChildren(el);
            }
          }
        }
      }
      card.dataset.compatibleSearch = normalize([
        makerEl ? makerEl.textContent : '',
        titleEl ? titleEl.textContent : '',
        name,
        card.dataset.compatibleCode || '',
        info ? info.value : '',
      ].join(' '));
    };

    cards.forEach(enrich);

    root.addEventListener('click', (event) => {
      const card = event.target.closest('.bnk-system-card');
      if (!card || !root.contains(card)) return;
      // Új lapon/ablakban megnyitás (Ctrl/Cmd/Shift/középső gomb) maradjon natív.
      if (event.defaultPrevented || event.button !== 0 || event.metaKey
          || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const value = card.dataset.compatibleValue || '';
      if (value) {
        // A választott rendszert megjegyezzük (a globális márkaválasztó cookie-ja), és
        // jelezzük, hogy a cél-oldal fejléc-szinkronja NE írja felül a saját vonalára.
        document.cookie = `bionika_brand=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
        try { sessionStorage.setItem('bnk_brand_menupick', '1'); } catch (error) {}
        document.dispatchEvent(new CustomEvent('bionika:brand-changed', { detail: { brand: value } }));
      }
      window.__bnkBrandNav = true;
      window.location.assign(card.getAttribute('href'));
    }, true);

    const filter = (rawValue = '') => {
      const query = normalize(rawValue);
      const terms = query.split(/\s+/).filter(Boolean);
      let visible = 0;

      groups.forEach((group) => {
        let shown = 0;
        group.cards.forEach((card) => {
          const haystack = card.dataset.compatibleSearch || normalize(card.textContent);
          const matches = terms.every((term) => haystack.includes(term));
          card.hidden = !matches;
          if (matches) shown += 1;
        });
        if (group.count) group.count.textContent = String(shown);
        group.element.hidden = shown === 0;
        visible += shown;
      });

      counter.textContent = String(visible);
      empty.hidden = visible !== 0;
      clear.hidden = query.length === 0;
    };

    input.addEventListener('input', () => filter(input.value));
    clear.addEventListener('click', () => {
      input.value = '';
      filter('');
      input.focus();
    });
    root.querySelectorAll('[data-compatible-query]').forEach((button) => {
      button.addEventListener('click', () => {
        input.value = button.dataset.compatibleQuery || '';
        filter(input.value);
        input.focus();
      });
    });
    root.querySelector('[data-compatible-reset]')?.addEventListener('click', () => {
      input.value = '';
      filter('');
      input.focus();
    });

    filter('');
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
